'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateEmailPreferences = exports.getEmailPreferences = undefined;

var _http = require('../../../utils/services/http');

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getEmailPreferences = exports.getEmailPreferences = function getEmailPreferences(_ref) {
    var email = _ref.email;

    var httpConfig = {
        url: 'users/email/preferences',
        method: 'get',
        params: {
            email: email
        }
    };

    return (0, _http2.default)(httpConfig);
};

var updateEmailPreferences = exports.updateEmailPreferences = function updateEmailPreferences(_ref2) {
    var email = _ref2.email,
        emailPreference = _ref2.emailPreference;

    var httpConfig = {
        url: 'users/email/preferences',
        method: 'put',
        data: {
            email: email,
            emailPreference: emailPreference
        }
    };

    return (0, _http2.default)(httpConfig);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/settings/emailPreferenceService.js
// module id = 2092
// module chunks = 0